module.exports = __webpack_public_path__ + "static/img/feature_04.6622b5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/ares/secondAnniversary/3/feature_04.png
// module id = FGfT
// module chunks = 10